module.exports = __webpack_public_path__ + "img/tooltip.be6891b6.svg";